var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ah-active-filter" }, [
    !!_vm.filter.symbol
      ? _c(
          "div",
          { staticClass: "ah-active-filter-icon-container" },
          [
            _c("animal-symbol", {
              staticClass: "ah-active-filter-icon",
              attrs: { name: _vm.filter.symbol }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "ah-active-filter-label" }, [
      _vm._v("\n    " + _vm._s(_vm.filter.name) + "\n  ")
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "ah-active-filter-close-icon",
      attrs: { src: _vm.removeFilterIconSrc, alt: _vm.accessibleLabel },
      on: { click: _vm.removeFilter }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }